export default __webpack_public_path__ + "static/media/line-angle-up-icon.acc1cead.svg";